/**
 * When running the local server, replaces the online domain with the local
 */
export const makeEnvironmentUrl = url => {
  if (process.env.REACT_APP_MODE === 'local' || process.env.REACT_APP_MODE === 'homolog') {
    const regex = /^(?:https?:\/\/)?(?:[\w.-]+)(\/.*)?$/;
    if (/\.aspx$/.test(url)) return url;
    const match = url.match(regex);
    return match && match[1] ? `${process.env.REACT_APP_URL}${match[1]}` : `${process.env.REACT_APP_URL}/home`;
  } else {
    return url;
  }
};
